customElements.get("dbtfy-shipping-calculator") || customElements.define("dbtfy-shipping-calculator", class extends HTMLElement {
  constructor() {
    super();

    this.data = Debutify.widgets["dbtfy-shipping-calculator"];
    this.countryId = this.dataset.countryId;
    this.provinceId = this.dataset.provinceId;
    this.provinceWrapperId = this.dataset.provinceWrapper;

    this.countryWrapper = this.querySelector("#dbtfy-shipping-calculator-country-wrapper");
    this.country = this.countryWrapper.querySelector(`#${this.countryId}`);
    this.provinceWrapper = this.querySelector(`#${this.provinceWrapperId}`);
    this.province = this.provinceWrapper.querySelector(`#${this.provinceId}`);
    this.zip = this.querySelector("#dbtfy-shipping-calculator-zip");
    this.alert = this.querySelector("#dbtfy-shipping-calculator-alert");
    this.btn = this.querySelector("button");

    if (this.data.length !== 0) {
      this.initCommonJsScript();
      this.btn.addEventListener("click", this.onSubmit.bind(this));
      this.shippingResponse = localStorage.getItem("shippingResponse");
    } else {
      this.remove();
    }
  }

  async initCommonJsScript() {
    const t = document.createElement("script");
    t.src = this.dataset.shopifyCommonJs;
    document.head.appendChild(t);

    await new Promise((res) => setTimeout(res, 1000));

    new window.Shopify.CountryProvinceSelector(this.countryId, this.provinceId, {
      hideElement: this.provinceWrapperId
    });

    this.country.options[0].textContent = this.country.getAttribute("aria-label");

    this.insertCustomerData();

    if (this.shippingResponse)
      this.updateAlertContent(this.shippingResponse, "alert-success");
  }

  insertCustomerData() {
    // Force United States only
    const defaultCountry = "United States";
    const defaultProvince = "New York";
    const defaultZip = "10001";

    this.country.value = defaultCountry;
    this.country.dispatchEvent(new CustomEvent("change"));
    localStorage.setItem("shippingCountry", defaultCountry);

    if (this.province) {
      this.province.value = defaultProvince;
      localStorage.setItem("shippingProvince", defaultProvince);
    }

    if (this.zip) {
      this.zip.value = defaultZip;
      localStorage.setItem("shippingZip", defaultZip);
    }
  }

  updateAlertClasses(status) {
    this.alert.classList.remove("alert-danger", "alert-warning", "alert-success");
    this.alert.classList.add(status);
  }

  updateAlertContent(content, statusClass) {
    const html = `
      <ul>
        ${content}
      </ul>
    `;
    if (statusClass.includes("success")) {
      localStorage.setItem("shippingResponse", content);
    } else {
      localStorage.removeItem("shippingResponse");
    }

    this.alert.innerHTML = html;
    this.updateAlertClasses(statusClass);
    this.alert.removeAttribute("hidden");
  }

  async onSubmit() {
    localStorage.setItem("shippingCountry", this.country.value);
    localStorage.setItem("shippingProvince", this.province.value);
    localStorage.setItem("shippingZip", this.zip.value);

    this.btn.classList.add("loading");
    this.btn.querySelector(".loading__spinner").classList.remove("hidden");

    const prepare = await fetch(
      `/cart/prepare_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`,
      { method: "POST" }
    );

    if (prepare.ok) {
      const asyncRates = await fetch(
        `/cart/async_shipping_rates.json?shipping_address[zip]=${this.zip.value}&shipping_address[country]=${this.country.value}&shipping_address[province]=${this.province.value}`
      );
      const result = await asyncRates.json();

      if (result.shipping_rates.length) {
        const content = result.shipping_rates
          .map(({ presentment_name, price, currency }) => `
              <li><strong>${presentment_name}</strong>: ${price} ${currency}</li>
            `)
          .join("");
        this.updateAlertContent(content, "alert-success");
      } else {
        this.updateAlertContent(this.data.text_no_results, "alert-warning");
      }
    } else {
      const error = await prepare.json();
      const errorHTML = Object.entries(error)
        .map(([_, msg]) => `<li>${msg}</li>`)
        .join("");
      this.updateAlertContent(errorHTML, "alert-danger");
    }

    this.btn.classList.remove("loading");
    this.btn.querySelector(".loading__spinner").classList.add("hidden");
  }
});
